export const INIT_APP = 'INIT_APP'
export const INIT_APP_FAIL = 'INIT_APP_FAIL'

export const INIT_APP_RESPONSE = 'INIT_APP_RESPONSE'
export const INIT_APP_RESPONSE_FAIL = 'INIT_APP_RESPONSE_FAIL'

export const MYZONE = 'MYZONE'
export const MYZONE_RESPONSE = 'MYZONE_RESPONSE'
export const MYZONE_RESPONSE_FAIL = 'MYZONE_RESPONSE_FAIL'

export const VARIFY_OTP = "VARIFY_OTP"
export const VARIFY_OTP_RESPONSE = 'VARIFY_OTP_RESPONSE'
export const VARIFY_OTP_RESPONSE_FAIL = 'VARIFY_OTP_RESPONSE_FAIL'

export const VALIDATE_USER = "VALIDATE_USER"
export const VALIDATE_USER_RESPONSE = 'VALIDATE_USER_RESPONSE'
export const VALIDATE_USER_RESPONSE_FAIL = 'VALIDATE_USER_RESPONSE_FAIL'

export const USER_LOG = "USER_LOG"
export const USER_LOG_RESPONSE = 'USER_LOG_RESPONSE'
export const USER_LOG_RESPONSE_FAIL = 'USER_LOG_RESPONSE_FAIL'

export const LOGIN_ATTEMPT = "LOGIN_ATTEMPT"
export const LOGIN_ATTEMPT_RESPONSE = "LOGIN_ATTEMPT_RESPONSE"
export const LOGIN_ATTEMPT_RESPONSE_FAIL = "LOGIN_ATTEMPT_RESPONSE_FAIL"

export const GET_STRATEGY = "GET_STRATEGY"
export const GET_STRATEGY_RESPONSE = "GET_STRATEGY_RESPONSE"
export const GET_STRATEGY_FAIL = "GET_STRATEGY_FAIL"

export const REPORT_SEND = "REPORT_SEND"
export const REPORT_SEND_RESPONSE = "REPORT_SEND_RESPONSE"
export const REPORT_SEND_FAIL = "REPORT_SEND_FAIL"

export const USER_ID = "USER_ID"
export const USER_ID_RESPONSE = "USER_ID_RESPONSE"

export const MYZONE_DATA = "MYZONE_DATA"
export const MYZONE_DATA_RESPONSE = "MYZONE_DATA_RESPONSE"

export const GET_ACCOUNT_PERFORMANCE = "GET_ACCOUNT_PERFORMANCE";
export const GET_ACCOUNT_PERFORMANCE_RESPONSE = "GET_ACCOUNT_PERFORMANCE_RESPONSE";
export const GET_ACCOUNT_PERFORMANCE_FAILED = "GET_ACCOUNT_PERFORMANCE_FAILED";

export const GET_CAPITAL_MOVEMENT = "GET_CAPITAL_MOVEMENT";
export const GET_CAPITAL_MOVEMENT_RESPONSE = "GET_CAPITAL_MOVEMENT_RESPONSE";
export const GET_CAPITAL_MOVEMENT_FAILED = "GET_CAPITAL_MOVEMENT_FAILED";

export const GET_CORPORATE_ACTION = "GET_CORPORATE_ACTION";
export const GET_CORPORATE_ACTION_RESPONSE = "GET_CORPORATE_ACTION_RESPONSE";
export const GET_CORPORATE_ACTION_FAILED = "GET_CORPORATE_ACTION_FAILED";

export const GET_DEBIT_NOTE = "GET_DEBIT_NOTE";
export const GET_DEBIT_NOTE_RESPONSE = "GET_DEBIT_NOTE_RESPONSE";
export const GET_DEBIT_NOTE_FAILED = "GET_DEBIT_NOTE_FAILED";

export const GET_TAXIBLE_GAIN = "GET_TAXIBLE_GAIN";
export const GET_TAXIBLE_GAIN_RESPONSE = "GET_TAXIBLE_GAIN_RESPONSE";
export const GET_TAXIBLE_GAIN_FAILED = "GET_TAXIBLE_GAIN_FAILED";

export const GET_HOLDING_STATEMENT = "GET_HOLDING_STATEMENT";
export const GET_HOLDING_STATEMENT_RESPONSE = "GET_HOLDING_STATEMENT_RESPONSE";
export const GET_HOLDING_STATEMENT_FAILED = "GET_HOLDING_STATEMENT_FAILED";

export const GET_AUDIT_REPORT_YEARS = "GET_AUDIT_REPORT_YEARS";
export const GET_AUDIT_REPORT_YEARS_RESPONSE = "GET_AUDIT_REPORT_YEARS_RESPONSE";
export const GET_AUDIT_REPORT_YEARS_FAILED = "GET_AUDIT_REPORT_YEARS_FAILED";

export const GET_AUDIT_REPORT = "GET_AUDIT_REPORT";
export const GET_AUDIT_REPORT_RESPONSE = "GET_AUDIT_REPORT_RESPONSE";
export const GET_AUDIT_REPORT_FAILED = "GET_AUDIT_REPORT_FAILED";

export const GET_AUDIT_REPORT_STRATEGY = "GET_AUDIT_REPORT_STRATEGY";
export const GET_AUDIT_REPORT_STRATEGY_RESPONSE = "GET_AUDIT_REPORT_STRATEGY_RESPONSE";
export const GET_AUDIT_REPORT_STRATEGY_FAILED = "GET_AUDIT_REPORT_STRATEGY_FAILED";

export const BITALY_LINK = "BITALY_LINK";
export const BITALY_LINK_RESPONSE = "BITALY_LINK_RESPONSE";
export const BITALY_LINK_FAILED = "BITALY_LINK_FAILED";

export const GET_ACCOUNT_STATEMENT = "GET_ACCOUNT_STATEMENT";
export const GET_ACCOUNT_STATEMENT_RESPONSE = "GET_ACCOUNT_STATEMENT_RESPONSE";
export const GET_ACCOUNT_STATEMENT_FAILED = "GET_ACCOUNT_STATEMENT_FAILED";

export const GET_MF_ACCOUNT_STATEMENT = "GET_MF_ACCOUNT_STATEMENT";
export const GET_MF_ACCOUNT_STATEMENT_RESPONSE = "GET_MF_ACCOUNT_STATEMENT_RESPONSE";
export const GET_MF_ACCOUNT_STATEMENT_FAILED = "GET_MF_ACCOUNT_STATEMENT_FAILED";

export const STRATEGY_CODE = "STRATEGY_CODE";
export const STRATEGY_CODE_RESPONSE = "STRATEGY_CODE_RESPONSE";
export const STRATEGY_CODE_FAILED = "STRATEGY_CODE_FAILED";

export const GET_MF_CAPITAL_GAIN_LOSS = "GET_MF_CAPITAL_GAIN_LOSS";
export const GET_MF_CAPITAL_GAIN_LOSS_RESPONSE = "GET_MF_CAPITAL_GAIN_LOSS_RESPONSE";
export const GET_MF_CAPITAL_GAIN_LOSS_FAILED = "GET_MF_CAPITAL_GAIN_LOSS_FAILED";

export const CHECK_AIF_DIT_PAN = "CHECK_AIF_DIT_PAN";
export const CHECK_AIF_DIT_PAN_RESPONSE = "CHECK_AIF_DIT_PAN_RESPONSE";
export const CHECK_AIF_DIT_PAN_FAILED = "CHECK_AIF_DIT_PAN_FAILED";

export const CHECK_PMS_DIT_PAN = "CHECK_PMS_DIT_PAN";
export const CHECK_PMS_DIT_PAN_RESPONSE = "CHECK_PMS_DIT_PAN_RESPONSE";
export const CHECK_PMS_DIT_PAN_FAILED = "CHECK_PMS_DIT_PAN_FAILED";


export const PMS_GET_AUDIT_REPORT_STRATEGY = "PMS_GET_AUDIT_REPORT_STRATEGY";
export const PMS_GET_AUDIT_REPORT_STRATEGY_RESPONSE = "PMS_GET_AUDIT_REPORT_STRATEGY_RESPONSE";
export const PMS_GET_AUDIT_REPORT_STRATEGY_FAILED = "PMS_GET_AUDIT_REPORT_STRATEGY_FAILED";

export const GET_ACCOUNT_PERFORMANCE_GROUP_WIS = "GET_ACCOUNT_PERFORMANCE_GROUP_WIS";
export const GET_ACCOUNT_PERFORMANCE_GROUP_WIS_RESPONSE = "GET_ACCOUNT_PERFORMANCE_GROUP_WIS_RESPONSE";
export const GET_ACCOUNT_PERFORMANCE_GROUP_WIS_FAILED = "GET_ACCOUNT_PERFORMANCE_GROUP_WIS_FAILED";

export const GET_FRACTION_LEDGER = "GET_FRACTION_LEDGER";
export const GET_FRACTION_LEDGER_RESPONSE = "GET_FRACTION_LEDGER_RESPONSE";
export const GET_FRACTION_LEDGER_FAILED = "GET_FRACTION_LEDGER_FAILED";

export const PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT = "PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT";
export const PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_RESPONSE = "PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_RESPONSE";
export const PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_FAILED = "PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_FAILED";

export const PMS_MANAGEMENT_FEES_LEDGER = "PMS_MANAGEMENT_FEES_LEDGER";
export const PMS_MANAGEMENT_FEES_LEDGER_RESPONSE = "PMS_MANAGEMENT_FEES_LEDGER_RESPONSE";
export const PMS_MANAGEMENT_FEES_LEDGER_FAILED = "PMS_MANAGEMENT_FEES_LEDGER_FAILED";

export const GET_MF_ACCOUNT_STATEMENT_INVESTOR = "GET_MF_ACCOUNT_STATEMENT_INVESTOR";
export const GET_MF_ACCOUNT_STATEMENT_INVESTOR_RESPONSE = "GET_MF_ACCOUNT_STATEMENT_INVESTOR_RESPONSE";
export const GET_MF_ACCOUNT_STATEMENT_INVESTOR_FAILED = "GET_MF_ACCOUNT_STATEMENT_INVESTOR_FAILED";

export const CHECK_MF_PAN_DIST = "CHECK_MF_PAN_DIST";
export const CHECK_MF_PAN_DIST_RESPONSE = "CHECK_MF_PAN_DIST_RESPONSE";
export const CHECK_MF_PAN_DIST_FAILED = "CHECK_MF_PAN_DIST_FAILED";

export const AUTHENTICATE_USER_BY_PAN = "AUTHENTICATE_USER_BY_PAN";
export const AUTHENTICATE_USER_BY_PAN_RESPONSE = "AUTHENTICATE_USER_BY_PAN_RESPONSE";
export const AUTHENTICATE_USER_BY_PAN_FAILED = "AUTHENTICATE_USER_BY_PAN_FAILED";

export const AUTHENTICATE_USER_BY_TOKEN = "AUTHENTICATE_USER_BY_TOKEN";
export const AUTHENTICATE_USER_BY_TOKEN_RESPONSE = "AUTHENTICATE_USER_BY_TOKEN_RESPONSE";
export const AUTHENTICATE_USER_BY_TOKEN_FAILED = "AUTHENTICATE_USER_BY_TOKEN_FAILED";

export const LOGOUT = 'LOGOUT';
